import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
export function useFeatureFlags() {
    return useContext(FeatureFlagsContext);
}
export const FeatureFlagsProvider = ({ featureFlags, children }) => {
    return (_jsx(FeatureFlagsContext.Provider, { value: Object.assign({}, featureFlags), children: children }));
};
export const FEATURE_FLAGS_ID_ATTRIBUTE = "BXP_CONTENT_FEATURE_FLAGS";
const FeatureFlagsContext = createContext({});
//# sourceMappingURL=use-feature-flags.js.map